// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad = require("../Control.Monad/index.js");
var Control_Monad_Reader_Class = require("../Control.Monad.Reader.Class/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Unsafe_Coerce = require("../Unsafe.Coerce/index.js");
var RIO = function (x) {
    return x;
};
var functorRIO = new Data_Functor.Functor($foreign.mapImpl);
var applyRIO = new Control_Apply.Apply(function () {
    return functorRIO;
}, $foreign.applyImpl);
var bindRIO = new Control_Bind.Bind(function () {
    return applyRIO;
}, $foreign.bindImpl);
var applicativeRIO = new Control_Applicative.Applicative(function () {
    return applyRIO;
}, $foreign.pureImpl);
var monadRIO = new Control_Monad.Monad(function () {
    return applicativeRIO;
}, function () {
    return bindRIO;
});
var monadAskRIO = new Control_Monad_Reader_Class.MonadAsk(function () {
    return monadRIO;
}, $foreign.askImpl);
var monadEffectRIO = new Effect_Class.MonadEffect(function () {
    return monadRIO;
}, Unsafe_Coerce.unsafeCoerce);
module.exports = {
    RIO: RIO,
    functorRIO: functorRIO,
    applyRIO: applyRIO,
    applicativeRIO: applicativeRIO,
    bindRIO: bindRIO,
    monadRIO: monadRIO,
    monadAskRIO: monadAskRIO,
    monadEffectRIO: monadEffectRIO,
    rio: $foreign.rio,
    runRIO: $foreign.runRIO,
    local: $foreign.local
};
//# sourceMappingURL=index.js.map
